import React, {useState} from 'react';
import { useLocation, useNavigate, Link, Routes, Route } from 'react-router';
import { useStore } from '@nanostores/react';

import _ from 'lodash';

import Schema from '../../stores/Schema.jsx';
import { $dataReady, $specializationsDict } from '../../stores/Dictionaries.jsx';
import { $currentFlags, $currentState, applyDiff, clearSavedState, markLoadApproved } from '../../stores/State.jsx';

import * as C from '../../controls/constraints.jsx';

import PersDataStepWidget from './PersDataStepWidget.jsx';
import InitialStepWidget from './InitialStepWidget.jsx';
import DocumentsStepWidget from './DocumentsStepWidget.jsx';
import EducationStepWidget from './EducationStepWidget.jsx';
import RepresentativesStepWidget from './RepresentativesStepWidget.jsx';
import AdditionalInfoStepWidget from './AdditionalInfoStepWidget.jsx';
import ContactsStepWidget from './ContactsStepWidget.jsx';
import { InputWidget } from '../../controls/widgets.jsx';
import { $productConfig } from '../../stores/Config.jsx';

const pages = [
    {
        id: '/', title: 'Согласие',
        validators: [
            'persdata_accepted'
        ]
    },
    {
        id: '/start', title: 'Общие сведения',
        validators: [
            'full_name', 'contact_phone', 'specialization'
        ],
        showIfValid: [
            'persdata_accepted'
        ]
    },
    {
        id: '/docs', title: 'Документы',
        validators: [
            'document_type',
            'passport_no', 'passport_issued_at', 'passport_code', 'passport_issued_by',
            'document_description', 'citizenship',
            'tax_id', 'ssn_id',
            'birth_date', 'birth_place', 'address_reg', 'address_living'
        ],
        showIfValid: [
            'persdata_accepted'
        ]

    },
    {
        id: '/education', title: 'Образование',
        validators: [
            'education_org', 'education_finished_at',
            'education_document_type', 'education_document_number', 'education_document_issue_date',
            'education_count_5', 'education_count_4', 'education_count_3',
            'education_prio_subjects'
        ],
        showIfValid: [
            'persdata_accepted'
        ]
    },
    {
        id: '/parents', title: 'Представители',
        validators: [
            'representatives'
        ],
        showIfValid: [
            'persdata_accepted'
        ]
    },
    {
        id: '/more', title: 'Дополнительно',
        validators: [
            'health_group', 'is_first_po'
        ],
        showIfValid: [
            'persdata_accepted'
        ]
    },
    {
        id: '/contacts', title: 'Контакты',
        validators: [
            'contact_phone', 'contact_phone_alt', 'contact_email', 'contact_social'
        ],
        showIfValid: [
            'persdata_accepted'
        ]        
    },
    {
        id: '/check_and_send', title: 'Отправка',
        validators: Schema,
        showIfValid: [
            'persdata_accepted'
        ]
    }
];

export const TritHeader = () => (
    <header>
        <img src="images/logo.png" alt="logo" />
        <h1>Приём заявления в электронном виде</h1>
        <br />
    </header>  
);

const RestorePageWidget = () => {
    const
        config = useStore($productConfig),
        //
        navigate = useNavigate(),
        [ pin, setPin ] = useState(''),
        [ loading, setLoading ] = useState(false),
        [ error, setError ] = useState(null),
        //
        onRestoreClicked = () => {
            setLoading(true);
            setError(null);

            fetch(config.restore_url, {
                'method': 'POST',
                'body': new URLSearchParams({'pin': pin})
            }).then(async (rsp) => {
                setLoading(false);
                if(rsp.status == 403) {
                    throw "Неверный код"
                }
                if(rsp.status != 200) {
                    throw rsp.statusText
                }
                rsp = await rsp.json()

                if (!_.isString(rsp['uid']) || !rsp['uid'].length) {
                    throw "Неверный ответ сервера"
                }

                navigate(`/status/${rsp.uid}`)

            })
            .catch((err) => {
                setLoading(false);
                setError(err);

            });
        };

    return (
        <div className="card">
            {loading
            ?<React.Fragment>
                <div className="card-body">
                    <div className="spinner-border"></div>
                    Ищем ваше заявление...
                </div>
            </React.Fragment>
            :<React.Fragment>
                <div className="card-body">
                    <p>
                    Уже заполняли заявление и потеряли свой QR-код?
                    Не беда, вы можете лично посетив приёмную комиссию получить одноразовый код 
                    и ввести его в это поле:
                    </p>
                    <input className="form-control" type="tel" placeholder="000 000 000" value={pin} onChange={(ev) => setPin(ev.target.value)} />
                    {error
                    ?<div className="alert alert-danger"><strong>Ошибка:</strong>{error}</div>
                    :null
                    }
                </div>
                <div className="card-footer">
                    <button className="btn btn-secondary" disabled={(_.isString(pin)&&pin.length>=9)?"":"disabled"} onClick={onRestoreClicked}>
                        Получить новый QR
                    </button>
                </div>
            </React.Fragment>

            }

        </div>
    );
}


export default () => {
    const
        location = useLocation(),
        navigate = useNavigate(),
        //
        dataReady = useStore($dataReady),
        flags = useStore($currentFlags),        
        specializations = useStore($specializationsDict),
        data = useStore($currentState),
        //
        showLoadedBanner = flags.isLoaded && !flags.isLoadApproved;

    const
        onLoadApprovedBtnClicked = () => {
            markLoadApproved();

        },
        onClearSavedDataBtnClicked = () => {
            clearSavedState();

            window.scrollTo(0, 0);
            navigate('/');    
        };


    if(!dataReady) return null;

    const
        specializationsFiltered = _.filter(specializations, function(a){ return (typeof a == 'object') && (a.closed !== true); }),
        noSpecializations = !specializationsFiltered.length;

    if(noSpecializations) {
        return (
            <div className="trit-container">
                <TritHeader />
                <div className="card mb-1">
                    <div className="card-body">
                        <h5 className="card-title">
                            <i className="bi bi-emoji-frown" />&nbsp;Приём заявлений закрыт
                        </h5>
                        В данный момент приём заявлений не проводится ни по одному направлению подготовки.
                    </div>
                </div>
                <RestorePageWidget />
            </div>
        );
    }

    let commonProps = {
        data: data,
        schema: Schema,
        onDataChanged: applyDiff
    };

    return (
        <div className="trit-container">
            <TritHeader />

            {(showLoadedBanner) ? (
                <div className="card">
                    <div className="card-body">
                        Мы обнаружили сохранённую версию заявления, вы можете продолжить заполнение или очистить данные и создать новое заявление.

                        <div>
                            <button className="btn btn-danger" onClick={onClearSavedDataBtnClicked}>
                                <i className="bi bi-x" />
                                &nbsp;
                                Заполнить новое заявление
                            </button>
                            &nbsp;
                            <button className="btn btn-success" onClick={onLoadApprovedBtnClicked}>
                                Продолжить редактирование
                                &nbsp;
                                <i className="bi bi-arrow-right" />
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}

            <br />

            <div className="row">
                <div className="col-sm-3">
                    <ul className="nav nav-pills flex-column">
                    {_.map(pages, function(v, k){
                        let
                              validators = C.AbstractConstraint.isConstraint(v.validators)
                                ? v.validators
                                : C.validateOnly(data, Schema, v.validators)
                            , vResult = C.validateSchema(data, validators)
                            //
                            , skipValidators = C.AbstractConstraint.isConstraint(v.showIfValid)
                                ? v.showIfValid
                                : C.validateOnly(data, Schema, v.showIfValid)
                            , vSkipResult = C.validateSchema(data, skipValidators)
                        ;

                        return (
                            (_.isUndefined(v.showIfValid) || vSkipResult.r)
                            ?<li key={k} className="nav-item">
                                <Link className={"nav-link" + ((location.pathname == v.id) ? " active" : "")} to={v.id}>
                                    {(!_.isUndefined(v.validators))
                                    ?(vResult.r
                                      ?<i className="bi bi-check text-success" />
                                      :<i className="bi bi-x text-danger" />
                                      )
                                    :null}
                                    {v.title}
                                </Link>
                            </li>
                            :null
                        )
                    })}
                    </ul>
                    <br />
                    <RestorePageWidget />
                </div>
                <div className="col-sm-9">
                    <a name="top" />
                    <Routes>
                        <Route path="/docs" element=<DocumentsStepWidget {...commonProps} /> />
                        <Route path="/education" element=<EducationStepWidget {...commonProps} /> />
                        <Route path="/parents" element=<RepresentativesStepWidget {...commonProps} /> />
                        <Route path="/more" element=<AdditionalInfoStepWidget {...commonProps} /> />
                        <Route path="/contacts" element=<ContactsStepWidget {...commonProps} /> />  
                        <Route path="/start" element=<InitialStepWidget {...commonProps} /> />
                        <Route path="/" element=<PersDataStepWidget {...commonProps} /> />
                    </Routes>
                </div>
            </div>

            <footer>
                &copy; 2025, <a target="_blank" href="http://izhtrit.ru">АПОУ УР &laquo;ТРИТ им. А.В.Воскресенского&raquo;</a>
                <div>Возникли проблемы? Звоните: <a href="tel:+73412570941">(3412) 57-09-41</a></div>
            </footer>

        </div>
    );
}

